<script setup lang="ts">
import type { Team } from '../../model/interfaces'

import { faPen, faTrashCan } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useTeamActions } from '../../model/teams/team-actions.hook'

defineOptions({
  name: 'TeamRowActions',
})

const props = defineProps<{
  team: Team
}>()

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  canManage,
  toggle,
  openEdit,
  openDelete,
} = useTeamActions({
  team: computed(() => props.team),
})
</script>

<template>
  <div
    ref="containerRef"
    class="team-row-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      view="table"
      :title="`Actions for ${team.name}`"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="team-row-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="Edit"
          color="blue"
          :prepend-icon="faPen"
          @click="openEdit"
        />
        <AppDropdownItem
          v-if="canManage"
          text="Delete"
          color="red"
          :prepend-icon="faTrashCan"
          @click="openDelete"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./TeamRowActions.scss" />
